// slices/hospitalLocationApiSlice.js

import { apiSlice } from './apiSlice';
import { HOSPITAL_LOCATION_URL } from '../constants';

export const hospitalLocationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHospitalLocations: builder.query({
      query: () => ({
        url: `${HOSPITAL_LOCATION_URL}`,
      }),
      keepUnusedDataFor: 5,
    }),

    getHospitalLocationById: builder.query({
      query: (id) => ({
        url: `${HOSPITAL_LOCATION_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGetHospitalLocationsQuery,
  useGetHospitalLocationByIdQuery,
} = hospitalLocationApiSlice;
